import { render } from "./InputTextGroup.vue?vue&type=template&id=21f89f78&scoped=true"
import script from "./InputTextGroup.vue?vue&type=script&lang=js"
export * from "./InputTextGroup.vue?vue&type=script&lang=js"

import "./InputTextGroup.vue?vue&type=style&index=0&id=21f89f78&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1337409007/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f89f78"]])

export default __exports__